module.exports = __webpack_public_path__ + "img/prev.d453b0f0.svg";